<template>
  <div class="vp-ml-2">
    <h3 class="massaction-section-title">{{ section.name }}</h3>
    <svg
      class="close-btn"
      @click="$bvModal.hide('sectionModal')"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
        fill="#F46A6A"
      />
    </svg>
    <RenderFieldType
      :addSeperator="true"
      :section="section"
      :isSignInMassAction="true"
      @updateCustomField="updateCustomField"
    />

    <button
      :disabled="$v.section.$invalid || !$v.section.$anyDirty"
      @click="emitFieldUpdate"
      class="section-submit-btn"
    >
      {{ section.isFilled ? updateBtnValue : addBtnValue }}
    </button>
  </div>
</template>

<script>
import RenderFieldType from "@/components/users/section/RenderFieldType";
import { mapGetters } from "vuex";
import { cloneDeep, difference , toUpper } from "lodash";
import { requiredIf } from "vuelidate/lib/validators";

export default {
  components: { RenderFieldType },
  data() {
    return {
      section: [],
      fieldData: null,
      dataOnLoad: null,
    };
  },
  validations: {
    section: {
      custom_fields: {
        $each: {
          value: {
            required: requiredIf(function (field) {
              return field.is_mandatory;
            }),
          },
        },
      },
    },
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
    isFormInputsValueUpdated() {
      //If section was previously filled , the mass action table
      //button value will always be 'Update'
      if (this.section.isFilled) return true;

      let isChanged = false;

      if (this.dataOnLoad.custom_fields && this.section.custom_fields) {
        this.dataOnLoad.custom_fields.forEach((mountData, index) => {
          const sectionFieldValue = this.section.custom_fields[index].value;
          if (mountData.type === "checkboxes") {
            // For checkboxes, check both length and content difference
            if (
              mountData.value.length !== sectionFieldValue.length ||
              !!difference(mountData.value, sectionFieldValue).length
            )
              isChanged = true;
          } else {
            // For other types, only compare values
            if (mountData.value != sectionFieldValue) isChanged = true;
          }
        });
      }

      return isChanged;
    },
    addBtnValue(){
      return toUpper(this.$t('common.add'))
    },
    updateBtnValue(){
      return toUpper(this.$t('common.update'))
    }
  },
  beforeMount() {
    this.section = cloneDeep(this.getModalInfo);
    this.dataOnLoad = cloneDeep(this.getModalInfo);
    console.log(this.$v.section);
    setTimeout(() => {
      this.$v.section.$reset();
    }, 0);
  },
  methods: {
    updateCustomField(field) {
      this.$v.section.$touch();
      let updatedFieldIndex = this.section.custom_fields?.findIndex(
        (customField) => customField.id == field.id
      );

      if (updatedFieldIndex >= 0)
        this.section.custom_fields[updatedFieldIndex] = field;

      this.section = cloneDeep(this.section);
    },
    emitFieldUpdate() {
      this.section.isFilled = this.isFormInputsValueUpdated;
      this.$emit("updateCustomField", this.section);
      this.$bvModal.hide("sectionModal");
    },
  },
};
</script>

<style lang="scss">
div#sectionModal___BV_modal_content_ {
  border-radius: 26px !important;

  .section-submit-btn {
    margin: 25px 0 17px 0;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;

    text-align: center;
    letter-spacing: 0.25px;
    width: 416px;
    height: 44px;
    border: none;
    font-weight: 700;
    font-size: 16px;
    line-height: 17px;
    color: #ffffff;
    border-radius: 22px;
    padding: 0px !important;
    background-color: #103f5e;
  }
  .section-submit-btn:disabled {
    background: #9fb2bf !important;
    cursor: not-allowed;
  }
  .massaction-section-title {
    font-weight: 700;
    font-size: 17px;
    line-height: 20.4px;
    text-align: center;
    margin: 0 0 40px 0;
    color: #000000;
  }
}
</style>
